import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { onMounted, onUnmounted, ref, computed, inject, nextTick, watch } from "vue";
import { useResizeObserver } from "@vueuse/core";
import { useCart } from "@/store/useCart";
import { Emitter } from "mitt";
import { DataLayerApi, FavoritesApi } from "@/services/Api";
import { useBreakpoints } from "@/code/useBreakpoints";
import Cookies from "js-cookie";



export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderWrapper',
  setup(__props) {

const { isLg, isSm } = useBreakpoints();
const cartStore = useCart();
const cartItems = computed<number>(() => {
  const sum = cartStore.rows.reduce((total, item) => total + item.quantity, 0);
  return sum;
});
const hiddenFooter = computed<boolean>(() => {
  return !!showCategory.value || showAbout.value;
});
const headerElement = ref<HTMLElement>(document.getElementById("header") as HTMLElement);
const isScrolled = ref<boolean>(false);
const isHamburgerMegaMenuOpen = ref<boolean>(false);
const scrolledTimeOut = ref<boolean>();
const hasLoaded = ref<boolean>(false);
const emitter = inject<Emitter<any>>("eventbus")!;
const hasFavorites = ref<boolean>(false);
const bodyEl = document.body as HTMLBodyElement;

useResizeObserver(bodyEl, () => {
  setBottomOnMegaMenu();
});

const onHamburgerMenuClick = () => {
  showMegaMenu.value = undefined;
  showCategory.value = undefined;
  isHamburgerMegaMenuOpen.value = !isHamburgerMegaMenuOpen.value;
  if (isHamburgerMegaMenuOpen.value) {
    bodyEl.classList.toggle("menu-opened");
  } else {
    bodyEl.classList.toggle("menu-opened");
  }
  setBottomOnHamburgerMenu();
  setBottomOnHamburgerMobileMenu();
};

const onHamburgerMenuClose = () => {
  isHamburgerMegaMenuOpen.value = false;
  bodyEl.style.overflow = "";
  bodyEl.classList.remove("menu-opened");
  setBottomOnHamburgerMenu();
};

function closeCartModal() {
  Cookies.remove('basket-da-dk');
  Cookies.remove('basket-nb-no');
  Cookies.remove('basket-sv-se');
  cartStore.isCartModalOpen = false;
}

const setBottomOnHamburgerMobileMenu = async () => {
  const hamburgerMobileContent = document.querySelector(".hamburger-mobile__content") as HTMLElement;
  if (!hamburgerMobileContent) {
    return;
  }
  const hamburgerMobileFooter = document.querySelector(".hamburger-mobile__footer") as HTMLElement;
  if (!hamburgerMobileFooter) {
    return;
  }
  await nextTick();
  hamburgerMobileContent.style.paddingBottom = `${hamburgerMobileFooter.offsetHeight}px`;
};

const isSearchFieldOpen = ref<boolean>(false);

const openSearchField = () => {
  isSearchFieldOpen.value = true;
};

const closeSearchField = () => {
  isSearchFieldOpen.value = false;
};

const onSearchFieldOpenClick = () => {
  openSearchField();
  scrolledTimeOut.value = true;
  setTimeout(() => {
    scrolledTimeOut.value = false;
  }, 1000);
};

const onSearchFieldClose = () => {
  closeSearchField();
};

const isCartPopUpOpen = ref<boolean>(false);

const openCartPopUp = () => {
  isCartPopUpOpen.value = true;
  DataLayerApi.createViewCartEvent();
};

const onCartPopUpCloseClick = () => {
  isCartPopUpOpen.value = false;
};

const showCategory = ref<string>();
const showAbout = ref<boolean>(false);

const onCategoryClick = (id: string) => {
  showCategory.value = id;
};

const onBackClick = () => {
  showCategory.value = undefined;
};

const onBackAboutClick = () => {
  showAbout.value = false;
};

const onAboutClick = () => {
  showAbout.value = true;
};

const onCartPopUpOpenClick = () => {
  openCartPopUp();
};

const canShowMegaMenu = ref<boolean>(false);
const showMegaMenu = ref<string>();
let showMegaMenuDelay = 0;

const onShowMegaMenuMouseEnter = (id: string) => {
  if (canShowMegaMenu.value && isLg.value) {
    clearTimeout(showMegaMenuDelay);
    showMegaMenuDelay = setTimeout(() => {
      isHamburgerMegaMenuOpen.value = false;
      showMegaMenu.value = id;
      if (showMegaMenu.value) {
        bodyEl.classList.add("menu-opened");
      } else {
        bodyEl.style.overflow = "";
        bodyEl.classList.remove("menu-opened");
      }
      setBottomOnMegaMenu();
    }, 300);
  }
};

const onShowMegaMenuMouseLeave = () => {
  if (isLg.value) {
    clearTimeout(showMegaMenuDelay);
    showMegaMenuDelay = setTimeout(() => {
      isHamburgerMegaMenuOpen.value = false;
      showMegaMenu.value = undefined;
      showCategory.value = undefined;
      if (showMegaMenu.value) {
        bodyEl.classList.add("menu-opened");
      } else {
        bodyEl.style.overflow = "";
        bodyEl.classList.remove("menu-opened");
      }
    }, 300);
  }
};

const setBottomOnMegaMenu = () => {
  if (showMegaMenu.value) {
    let container = document.getElementById(showMegaMenu.value);
    let container1 = document.getElementById(showMegaMenu.value + "1");
    if (isScrolled.value) {
      container = document.getElementById(showMegaMenu.value + "2");
      container1 = document.getElementById(showMegaMenu.value + "3");
    }
    if (container && container1) {
      if (container?.clientHeight >= container1?.scrollHeight) {
        container.style.bottom = "initial";
      } else {
        container.style.bottom = "0";
      }
    }
  }
};

const setBottomOnHamburgerMenu = () => {
  if (isHamburgerMegaMenuOpen.value) {
    let container = document.getElementById("hamburger-about");
    let container1 = document.getElementById("hamburger-about1");
    if (container && container1) {
      if (container?.clientHeight >= container1?.scrollHeight) {
        container.style.bottom = "initial";
      } else {
        container.style.bottom = "0";
      }
    }
  }
};

const showAccordion = ref<string>();
const maxAccordionHeight = ref<number>(0);

const getAccordionContentHeight = (sourceElement: HTMLElement | null): number => {
  const accordionContent = sourceElement?.closest(".accordion")?.querySelector(".accordion__content");
  return accordionContent?.scrollHeight ?? 0;
};

const onOpenAccordion = (ev: Event, id: string) => {
  if (showAccordion.value == id) {
    showAccordion.value = undefined;
  } else {
    showAccordion.value = id;
  }
  if (showAccordion.value != undefined) {
    maxAccordionHeight.value = getAccordionContentHeight(ev.target as HTMLElement);
  } else {
    maxAccordionHeight.value = 0;
  }
};

const loadFavorites = async () => {
  const hasFavoritesFromApi = await FavoritesApi.hasFavorites();
  hasFavorites.value = hasFavoritesFromApi;
};

onMounted(() => {
  hasLoaded.value = true;
  headerElement.value = document.getElementById("header") as HTMLElement;
  document.addEventListener("click", onOutsideClick);

  window.onscroll = () => {
    scrollCalc();
    setTimeout(scrollCalc, 500);
  };

  const scrollCalc = () => {
    if (window.scrollY > headerElement.value.offsetHeight) {
      if (!isScrolled.value) {
        isScrolled.value = true;
      }
    } else {
      if (isScrolled.value) {
        isScrolled.value = false;
      }
    }
  };

  setTimeout(() => {
    canShowMegaMenu.value = true;
  }, 500);

  setTimeout(() => {
    DataLayerApi.getUserInfoEvent();
  }, 500);

  emitter.on("openCart", () => {
    openCartPopUp();
  });

  emitter.on("favoriteAdded", () => {
    hasFavorites.value = true;
  });

  emitter.on("favoriteRemoved", async () => {
    const hasFavoritesFromApi = await FavoritesApi.hasFavorites();
    hasFavorites.value = hasFavoritesFromApi;
  });

  loadFavorites();
});

onUnmounted(() => {
  document.removeEventListener("click", onOutsideClick);
});

const onOutsideClick = (ev: MouseEvent) => {
  if (
    !(ev.target as HTMLElement).closest(".categories__category") &&
    !(ev.target as HTMLElement).closest(".mega-menu-container")
  ) {
    showMegaMenu.value = undefined;
    bodyEl.style.overflow = "";
  }
};

watch(isScrolled, (value) => {
  headerElement.value.classList.toggle("header--sticky", value);
});

const tryCloseHamburgerMegaMenu = (ev: Event) => {
  const element = ev.target as HTMLElement;
  if (
    !element.closest("#hamburger-about") &&
    !element.closest(".icon-hamburger-menu, .hamburger-button") &&
    !element.closest(".hamburger-mobile") &&
    isLg.value
  ) {
    onHamburgerMenuClose();
  }
};

watch(isHamburgerMegaMenuOpen, (value) => {
  if (value) {
    document.addEventListener("click", tryCloseHamburgerMegaMenu);
  } else {
    document.removeEventListener("click", tryCloseHamburgerMegaMenu);
  }
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    isScrolled: isScrolled.value,
    onHamburgerMenuClick: onHamburgerMenuClick,
    isHamburgerMegaMenuOpen: isHamburgerMegaMenuOpen.value,
    showCategory: showCategory.value,
    onBackClick: onBackClick,
    showAccordion: showAccordion.value,
    onOpenAccordion: onOpenAccordion,
    maxAccordionHeight: maxAccordionHeight.value,
    showAbout: showAbout.value,
    onAboutClick: onAboutClick,
    onBackAboutClick: onBackAboutClick,
    showMegaMenu: showMegaMenu.value,
    hasLoaded: hasLoaded.value,
    onShowMegaMenuMouseEnter: onShowMegaMenuMouseEnter,
    onShowMegaMenuMouseLeave: onShowMegaMenuMouseLeave,
    onCategoryClick: onCategoryClick,
    cartItems: cartItems.value,
    onSearchFieldOpenClick: onSearchFieldOpenClick,
    isSearchFieldOpen: isSearchFieldOpen.value,
    isSearchFieldOpen2: isSearchFieldOpen.value,
    onSearchFieldClose: onSearchFieldClose,
    scrolledTimeOut: scrolledTimeOut.value,
    onCartPopUpOpenClick: onCartPopUpOpenClick,
    isCartPopUpOpen: isCartPopUpOpen.value,
    onCartPopUpCloseClick: onCartPopUpCloseClick,
    hasFavorites: hasFavorites.value,
    isLg: _unref(isLg),
    isSm: _unref(isSm),
    hiddenFooter: hiddenFooter.value,
    isCartModalOpen: _unref(cartStore).isCartModalOpen,
    closeCartModal: closeCartModal
  })
}
}

})